import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserAccess } from "../../Services/ApiCalling/User";
import {
  getRaTendersBiddersList,
  getTenderList,
  getTendersBiddersList,
  getTenderSpeceficDetail,
} from "../../Services/ReverseAuction/GetApi";

export const auctionGet = createAsyncThunk(
  "auctionGet/get",
  async ({ section, tenderType, page = 0, auctionType }) => {
    try {
      let data = await getTenderList({
        section,
        tenderType,
        page,
        auctionType,
      });
      return { user: data };
    } catch (err) {
      console.error("Thunk auctionGet - Error:", err);
    }
  },
);

export const tenderSpecefic = createAsyncThunk(
  "tenderSpecefic/get",
  async (id) => {
    try {
      let data = await getTenderSpeceficDetail(id);
      return { user: data };
    } catch (err) {}
  },
);

export const auctionBidders = createAsyncThunk(
  "auctionBidders/get",
  async ({ section, tenderType, page = 0, auctionType }) => {
    try {
      let data = await getTendersBiddersList({
        section,
        tenderType,
        page,
        auctionType,
      });
      return { user: data };
    } catch (err) {}
  },
);

export const auctionBiddersRa = createAsyncThunk(
  "auctionBiddersRa/get",
  async () => {
    try {
      let data = await getRaTendersBiddersList();
      return { user: data };
    } catch (err) {}
  },
);

export const activeTenderId = createAsyncThunk(
  "activeTenderId/get",
  async (id) => {
    try {
      return { id };
    } catch (err) {}
  },
);

export const activeView = createAsyncThunk("activeView/get", async (id) => {
  try {
    return { id };
  } catch (err) {}
});

const auctionSlice = createSlice({
  name: "auction",
  initialState: {
    tenderSpecefic: null,
    auctionGet: null,
    auctionTotalPages: 0,
    auctionCurrentPage: 0,
    activeTenderId: null,
    activeView: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearAuctionData: (state) => {
      state.auctionGet = null;
    },
    resetActiveView: (state) => {
      state.activeView = null;
    },
    setActiveView: (state, action) => {
      state.activeView = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(auctionGet.pending, (state, action) => {
        if (action.meta.arg.activeView) {
          state.activeView = action.meta.arg.activeView;
        }
        if (!action.meta.arg.silent) {
          state.auctionGet = null;
        }
      })
      .addCase(auctionGet.fulfilled, (state, action) => {
        // Try to access data from nested structure first, then try alternative paths
        const innerData = action.payload?.user?.data?.data;
        const alternativeData = action.payload?.user?.data;
        const data = innerData || alternativeData;

     

        state.auctionGet = data?.page;

        // Calculate totalPages from totalElements and size if totalPages not provided
        const providedTotalPages = data?.totalPages;
        const calculatedTotalPages = Math.ceil(
          (data?.totalElements || 0) / (data?.size || 10),
        );
        const totalPages = providedTotalPages ?? calculatedTotalPages;

 

        state.auctionTotalPages = totalPages;
        state.auctionCurrentPage = data?.currentPage ?? 0;
      })
      .addCase(auctionGet.rejected, (state, action) => {});
    builder
      .addCase(tenderSpecefic.pending, (state) => {})
      .addCase(tenderSpecefic.fulfilled, (state, action) => {
        state.tenderSpecefic = action.payload?.user?.data?.data;
      })
      .addCase(tenderSpecefic.rejected, (state, action) => {});
    builder
      .addCase(auctionBidders.pending, (state, action) => {
        if (action.meta.arg.activeView) {
          state.activeView = action.meta.arg.activeView;
        }
        if (!action.meta.arg.silent) {
          state.auctionGet = null;
        }
      })
      .addCase(auctionBidders.fulfilled, (state, action) => {
        // Try to access data from nested structure first, then try alternative paths
        const innerData = action.payload?.user?.data?.data;
        const alternativeData = action.payload?.user?.data;
        const data = innerData || alternativeData;

        state.auctionGet = data?.page;

        // Calculate totalPages from totalElements and size if totalPages not provided
        const providedTotalPages = data?.totalPages;
        const calculatedTotalPages = Math.ceil(
          (data?.totalElements || 0) / (data?.size || 10),
        );
        const totalPages = providedTotalPages ?? calculatedTotalPages;

        state.auctionTotalPages = totalPages;
        state.auctionCurrentPage = data?.currentPage ?? 0;
      })
      .addCase(auctionBidders.rejected, (state, action) => {});
    builder
      .addCase(auctionBiddersRa.pending, (state) => {})
      .addCase(auctionBiddersRa.fulfilled, (state, action) => {
        state.auctionGet = action.payload?.user?.data?.data;
      })
      .addCase(auctionBiddersRa.rejected, (state, action) => {});
    builder
      .addCase(activeTenderId.pending, (state) => {})
      .addCase(activeTenderId.fulfilled, (state, action) => {
        state.activeTenderId = action.payload?.id;
      })
      .addCase(activeTenderId.rejected, (state, action) => {});
    builder
      .addCase(activeView.pending, (state) => {})
      .addCase(activeView.fulfilled, (state, action) => {
        state.activeView = action.payload?.id;
      })
      .addCase(activeView.rejected, (state, action) => {});
  },
});

export const { clearAuctionData, resetActiveView, setActiveView } = auctionSlice.actions;
export default auctionSlice.reducer;
